function closeSearch() {
  console.log("close");
  let elements = document.querySelectorAll(".search-modal__form");

  elements.forEach((element) => {
    element.removeAttribute("open");
  });

  document.body.style.overflowY = "scroll";
  document.body.style.position = "relative";
}
function showSearch() {
  let element = document.querySelector(".search-modal__form");
  element.setAttribute("open", "true");
  document.body.style.overflowY = "scroll";
  document.body.style.position = "fixed";
  document.body.style.left = "0px";
  document.body.style.right = "0px";
}
function saveChosenDogbreed() {
  let dogbreedSelector = document.getElementById("dogbreeds");
  let dogbreedText = document.getElementById("hondenkiezerText");
  localStorage.setItem("dogbreed", dogbreedSelector.value);
  dogbreedUrl = dogbreedSelector[dogbreedSelector.options.selectedIndex].value;
  console.log(dogbreedText);
  if (parseInt(dogbreedUrl) == 0) {
    dogbreedText.classList.remove("opacity-0");
  } else {
    window.location.href = "/" + dogbreedUrl + "/";
  }
}

function showFiltersMobile() {
  let filtersDiv = document.querySelector(".filters");
  filtersDiv.style.display = "block";
}
function hideFiltersMobile() {
  console.log("hide filters");
  let filtersDiv = document.querySelector(".filters");
  filtersDiv.style.display = "none";
}

// function showSearch() {
//   let searchForm = document.getElementById("mobileFormSearch");
//   if (searchForm.style.display == "flex") {
//     searchForm.style.display = "none";
//   } else {
//     searchForm.style.display = "flex";
//   }
// }

// collection page
function categoryReadMore() {
  let categoryText = document.getElementsByClassName("collectionEnd");
  categoryText[0].scrollIntoView({ behavior: "smooth", block: "start" });
}

async function fetchProduct(productUrl, productCounter, sliderCheck) {
  const url = "https://www.autobench.nl/" + productUrl;
  let product = await await fetch(url, { method: "GET" })
    .then((response) => response.json())
    .then((data) => (prod = data));
  //  voorraad/stock
  showStock(product, productCounter);
  showCartButton(product, productCounter);
  //  measurements
  if (
    product.data_02 != "0x0x0" &&
    product.data_02 != "" &&
    product.title.includes("bench")
  ) {
    // showMeasurements(product, productCounter);
  }
  //   variants
  if (sliderCheck == false || sliderCheck == undefined) {
    let variants = Object.entries(product.variants);
    if (variants.length > 1) {
      showVariants(product, productCounter);
    }
  }
}

function showCartButton(product, productCounter) {
  let cartButton = document.getElementsByClassName("CartButton");
  if (product.stock.level > 0) {
    // pass
  } else {
    cartButton[productCounter].classList.add("hidden");
  }
}

function showMeasurements(product, productCounter) {
  let afmetingenDiv = document.getElementsByClassName("afmetingen");
  let data02 = product.data_02;
  let measurements = data02;
  if (data02.includes("x") && data02.includes("-")) {
    let afmetingList = data02.split("-");
    measurements = afmetingList[1];
    measurements = afmetingList[1].split("x");
  }
  let hoogte = measurements[0];
  let breedte = measurements[1];
  let diepte = measurements[2];

  if (data02.includes("LxBxH")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[1];
    diepte = afmetingList[0];
  } else if (data02.includes("BxDxH")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[0];
    diepte = afmetingList[1];
  } else if (data02.includes("LxBxDikte")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[1];
    diepte = afmetingList[0];
  }

  for (let i = 0; i < measurements.length; i++) {
    let liElement = document.createElement("li");
    liElement.className = "pr-2 text-xs md:text-sm";
    if (i == 0) {
      liElement.innerHTML =
        "<span class='font-bold text-base'>H </span>" + hoogte + "cm";
    } else if (i == 1) {
      liElement.innerHTML =
        "<span class='font-bold text-base'>B </span>" + breedte + "cm";
    } else {
      liElement.innerHTML =
        "<span class='font-bold text-base'>D </span> " + diepte + "cm";
    }
    afmetingenDiv[productCounter].children[0].append(liElement);
  }
}

// product page
function scrollToSpecs() {
  let specsDiv = document.getElementsByClassName("productSpecifications");
  specsDiv[0].scrollIntoView({ behavior: "smooth", block: "center" });
}

function scrollToRelated() {
  let relatedDiv = document.getElementsByClassName("productRelated");
  relatedDiv[0].scrollIntoView({ behavior: "smooth", block: "center" });
}

function showProductText() {
  let productTextDiv = document.getElementsByClassName("productTextContent");
  const readmoreBtn = document.getElementById("readMoreBtn");
  readmoreBtn.remove();
  productTextDiv[0].classList.remove("overflow-hidden");
  productTextDiv[0].style.maxHeight = "fit-content";
}

// navigation functions
function hideCategories() {
  console.log("hide");
  let categoriesDiv = document.getElementById("categoriesContainer");
  if (categoriesDiv.style.visibility == "visible") {
    categoriesDiv.style.visibility = "hidden";
    categoriesDiv.style.maxHeight = "0px";
    categoriesDiv.style.opacity = "0";
    document.body.style.overflowY = "scroll";
    document.body.style.position = "relative";
    document.body.style.left = "0px";
    document.body.style.right = "0px";
  }
  if (document.body.style.position != "relative") {
    let elements = document.querySelectorAll(".search-modal__form");
    elements.forEach((element) => {
      element.removeAttribute("open");
    });

    document.body.style.overflowY = "scroll";
    document.body.style.position = "relative";
  }
}

let catCheck = 0;
function showCategories() {
  let categoriesDiv = document.getElementById("categoriesContainer");
  if (categoriesDiv.style.visibility == "visible") {
    categoriesDiv.style.visibility = "hidden";
    categoriesDiv.style.maxHeight = "0px";
    categoriesDiv.style.opacity = "0";
    document.body.style.overflowY = "scroll";
    document.body.style.position = "relative";
  } else {
    catCheck = 1;
    categoriesDiv.style.visibility = "visible";
    categoriesDiv.style.maxHeight = "99999px";
    categoriesDiv.style.opacity = "1";
    document.body.style.overflowY = "scroll";
    document.body.style.position = "fixed";
    document.body.style.left = "0px";
    document.body.style.right = "0px";
  }
  event.stopPropagation();
}

// toggle fags on textpage
function showFaq(ele) {
  console.log(ele);
  let faqDiv = ele.nextElementSibling;
  if (faqDiv.classList.contains("!hidden")) {
    faqDiv.classList.remove("!hidden");
    ele.parentElement.classList.add("min-h-[80px]");
    ele.children[1].style.rotate = "180deg";
  } else {
    faqDiv.classList.add("!hidden");
    ele.parentElement.classList.remove("min-h-[80px]");
    ele.children[1].style.rotate = "360deg";
  }
}

// SHOPIFY NEW

// collection/category page functions
// Update the variant ID when the selection changes
const variantSelectors = document.querySelectorAll(".variationsPicker");

variantSelectors.forEach((selector) => {
  selector.addEventListener("change", function () {
    selector.parentElement.parentElement.children[0].children[2].value =
      selector.value;
    let selectedText = selector.options[selector.selectedIndex].text;
    let splitText = selectedText.split(" - ");
    // change price
    selector.parentElement.parentElement.parentElement.children[1].children[2].innerText =
      splitText[1];
    console.log(selector);
  });
});

// timeout with promise
function timeout(ms) {
  // console.log('timeout called');
  return new Promise((resolve) => setTimeout(resolve, ms));
}
